<template lang="pug">
div(v-if="city")
  v-dialog(v-model="dialog", width="828")
    v-card
      v-toolbar(flat, dense)
        .subtitle-2 Edit Parallax
      v-card-text
        v-slider(
          v-model="height",
          min="200",
          max="600",
          step="5",
          label="Height",
          thumb-label="always",
          color="secondary",
          track-color="success"
        )
        .text-center
          croppa(
            v-model="myCroppa",
            :width="800",
            :height="height",
            :quality="2",
            :canvas-color="canvas_color",
            initial-size="contain"
          )
        v-text-field(
          v-model="canvas_color",
          label="Background Color",
          hint="Name, hex code, or valid color format"
        )
      v-card-actions
        v-btn(
          @click="generateBlob",
          block,
          color="secondary",
          :loading="loading"
        ) Save Parallax
</template>

<script>
import { EventBus } from "@/event-bus.js";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      city: null,
      height: 400,
      mediaHost: process.env.VUE_APP_MEDIAHOST,
      myCroppa: {},
      loading: false,
      dialog: false,
      canvas_color: "#FFFFFF",
    };
  },
  mounted() {
    EventBus.$on("edit-city-parallax", this.open);
  },
  destroyed() {
    EventBus.$off("edit-city-parallax", this.open);
  },
  methods: {
    ...mapActions(["updateCity"]),
    open(data) {
      this.city = data;
      this.dialog = true;
    },
    generateBlob() {
      this.myCroppa.generateBlob(
        (blob) => {
          if (!blob) {
            this.myCroppa.chooseFile();
            return;
          }
          this.uploadLogo(blob);
        },
        "image/jpeg",
        0.8
      );
    },
    async uploadLogo(blob) {
      if (!this.city || !this.city._id) return;
      this.loading = true;
      const cityId = this.city._id;
      const formData = new FormData();
      formData.append("file", blob);
      formData.append("cityId", cityId);
      try {
        const res = await this.axios.post("/city/updateParallax", formData);
        this.updateCity(res.data);
        this.dialog = false;
      } catch (err) {
        this.$toast.error(err.response?.data || err.message);
      }
      this.loading = false;
    },
  },
};
</script>